import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import ProfileModal from "./ProfileModal";
import axios from "axios";

const ProfileBox = (props) => {
        const [initials, setInitials] = useState("");
        const [open, setOpen] = useState(false);
        const [pos, setPos] = useState({ top: 0, left: 0, width: 0 });
        const anchorRef = useRef(null);
        const navigate = useNavigate();
        const [modalIsOpen, setModalIsOpen] = useState(false);

        useEffect(() => {
                const fullName = props.teacher.firstName + " " + props.teacher.lastName;
                setInitials(
                        fullName.split(" ")
                                .map((n) => n[0])
                                .join("")
                                .toUpperCase()
                                .slice(0, 2)
                );
        }, [props.teacher.firstName, props.teacher.lastName]);

        const updatePosition = () => {
                const el = anchorRef.current;
                if (!el) return;
                const rect = el.getBoundingClientRect();
                // Place popover just below the anchor and right aligned
                setPos({ top: rect.bottom + 8, left: rect.right, width: rect.width });
        };

        useLayoutEffect(() => {
                if (!open) return;
                updatePosition();
                const onKey = (e) => e.key === "Escape" && setOpen(false);
                const onDocClick = (e) => {
                        if (!anchorRef.current) return;
                        // Close if click is outside anchor and outside the menu (menu is in a portal - we check by id)
                        const menu = document.getElementById("profile-menu-popover");
                        if (!anchorRef.current.contains(e.target) && !(menu && menu.contains(e.target))) {
                                setOpen(false);
                        }
                };
                window.addEventListener("scroll", updatePosition, true);
                window.addEventListener("resize", updatePosition);
                document.addEventListener("keydown", onKey);
                document.addEventListener("mousedown", onDocClick);
                return () => {
                        window.removeEventListener("scroll", updatePosition, true);
                        window.removeEventListener("resize", updatePosition);
                        document.removeEventListener("keydown", onKey);
                        document.removeEventListener("mousedown", onDocClick);
                };
        }, [open]);

        const handleAnchorClick = () => setOpen((prev) => !prev);

        const handleSignOut = async () => {
                setOpen(false);
                await logout();
        };

        const logout = async () => {
                try {
                        const res = await axios.post("/api/teachers/logout", {}, {
                                headers: {
                                        'Content-Type': 'application/json'
                                },
                                withCredentials: true
                        },);

                        navigate("/login");
                } catch (err) {
                        alert("Error signing out. Please try again later.");
                }
        };

        return (
                <div className="nav-profile">
                        <div className="profile-icon">{initials}</div>

                        <div className="profile-content">
                                <div className="profile-name">{props.teacher.firstName + " " + props.teacher.lastName}</div>
                                <div className="profile-school">{props.teacher.school.name}</div>
                        </div>

                        <div className="profile-menu"
                                ref={anchorRef}
                                onClick={handleAnchorClick}
                                role="button"
                                aria-haspopup="menu"
                                aria-expanded={open}
                                tabIndex={0}
                                onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                                e.preventDefault();
                                                handleAnchorClick();
                                        }
                                }}
                        >
                                <span className="circle-menu-dot" />
                                <span className="circle-menu-dot" />
                                <span className="circle-menu-dot" />
                        </div>

                        {open &&
                                createPortal(
                                        <div
                                                id="profile-menu-popover"
                                                className="profile-menu-popover"
                                                role="menu"
                                                style={{
                                                        position: "fixed",
                                                        top: `${pos.top}px`,
                                                        left: `${pos.left}px`,
                                                        transform: "translateX(-100%)",
                                                        zIndex: 1000,
                                                        minWidth: Math.max(120, pos.width),
                                                }}
                                        >
                                                <button className="popover-menu-item" role="menuitem" onClick={() => { setModalIsOpen(true); setOpen(false); }}>
                                                        <div><img className="popover-menu-icon" src="../icons/cog-blue.svg" alt="Settings Icon" /></div>
                                                        <div>Settings</div>
                                                </button>

                                                <button className="popover-menu-item" role="menuitem" onClick={handleSignOut}>
                                                        <div><img className="popover-menu-icon" src="../icons/signout-blue.svg" alt="Settings Icon" /></div>
                                                        <div>Sign out</div>
                                                </button>
                                        </div>,
                                        document.body // render at top level
                                )}
                        <ProfileModal open={modalIsOpen} onClose={() => setModalIsOpen(false)} />
                </div>
        );
};

export default ProfileBox;